import { toApiFilters } from "@/components/asset_filter/filterQuery";

export const DEFAULT_REMOVE_DUPLICATES_FILTER = [{ type: 9, value: 'No' }];

export function buildRemoveDuplicatesDescription(filters) {
  const assetFilter = toApiFilters(filters == null ? [] : filters);
  return JSON.stringify({ asset_filter: assetFilter });
}

export function assetFilterFromJobDescription(description) {
  if (!description || typeof description !== 'object') {
    return [];
  }
  if (description.asset_filter == null) {
    return [];
  }
  if (typeof description.asset_filter === 'string') {
    try {
      return toApiFilters(JSON.parse(description.asset_filter));
    } catch (_) {
      return [];
    }
  }
  return toApiFilters(description.asset_filter);
}
